import React from "react";
import "./Header.css";
import headerLogo from "./Images/header-logo.jpeg.png";
import { useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';

function Header() {
  const navigate = useNavigate();

  const navigateToHomepage = () => {
    navigate('/homepage');
  };

  return (
    <div className="Header-component">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <img src={headerLogo} alt="headerLogo" className="header-logo" />
        <div
          style={{
            padding: "5px",
            marginRight: "20px",
            cursor: "pointer",
          }}
          onClick={navigateToHomepage}
        >
          <HomeIcon 
            sx={{
              fontSize: '24px',
              color: 'black',
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Header;
